(function () {
  var rootSelector = '[data-talli-filter-root]';
  var itemSelector = '[data-talli-product-item]';
  var instances = new WeakMap();

  function parseJson(value, fallback) {
    if (!value) return fallback;

    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function uniqueValues(values) {
    return values.filter(function (value, index) {
      return value && values.indexOf(value) === index;
    });
  }

  function normalizeHandle(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/ß/g, 'ss')
      .replace(/&/g, ' en ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function containsAny(value, needles) {
    return needles.some(function (needle) {
      return value.indexOf(needle) !== -1;
    });
  }

  function resolveCategoryTag(tag, label, collectionHandle) {
    var normalizedTag = normalizeHandle(tag);
    if (normalizedTag === 'all') return 'all';

    var basis = [
      normalizedTag,
      normalizeHandle(label),
      normalizeHandle(collectionHandle)
    ].join('-');

    if (containsAny(basis, ['rvs-lunchboxen', 'lunchbox', 'broodtrommel', 'brotdose', 'brotdosen', 'brot-dose', 'brotbox', 'brotboxen'])) {
      return 'rvs-lunchboxen';
    }

    if (containsAny(basis, ['rvs-snackboxen', 'snackbox', 'snackboxen-aus-edelstahl', 'snackdoos', 'snack-dose'])) {
      return 'rvs-snackboxen';
    }

    if (containsAny(basis, ['cat-bekers', 'beker', 'bekers', 'mok', 'mokken', 'becher', 'tasse', 'tassen', 'cup', 'cups'])) {
      return 'cat-bekers';
    }

    if (containsAny(basis, ['cat-schalen', 'schaal', 'schalen', 'schaaltjes', 'schussel', 'schuessel', 'bowl', 'bowls'])) {
      return 'cat-schalen';
    }

    if (containsAny(basis, ['borden', 'bord', 'teller', 'schild', 'schilder', 'plate', 'plates'])) {
      return 'borden';
    }

    if (containsAny(basis, ['stickers', 'sticker', 'aufkleber'])) {
      return 'stickers';
    }

    if (containsAny(basis, ['refined'])) {
      return 'refined';
    }

    return normalizedTag;
  }

  var categoryBlockTags = {
    lunchboxen: 'rvs-lunchboxen',
    snackboxen: 'rvs-snackboxen',
    borden: 'borden',
    bekers: 'cat-bekers',
    schalen: 'cat-schalen',
    'category-jgnyjc': 'stickers',
    stickers: 'stickers',
    voorraadpotten: 'refined',
    refined: 'refined'
  };

  function resolveCategoryButtonTag(button) {
    var categoryId = normalizeHandle(button.dataset.talliCategoryId);

    if (categoryId && categoryBlockTags[categoryId]) {
      return categoryBlockTags[categoryId];
    }

    return resolveCategoryTag(
      button.dataset.talliCategoryTag,
      button.textContent,
      button.dataset.talliCollectionHandle
    );
  }

  var subcategoryCanonicalTags = {
    '3-in-1': 'sub-3-in-1',
    '3in1': 'sub-3-in-1',
    'sub-3-in-1': 'sub-3-in-1',
    'set-van-2': 'sub-set-van-2',
    '2er-set': 'sub-set-van-2',
    'sub-2er-set': 'sub-set-van-2',
    'set-of-2': 'sub-set-van-2',
    'sub-set-of-2': 'sub-set-van-2',
    'set-2': 'sub-set-van-2',
    'sub-set-van-2': 'sub-set-van-2',
    'met-vakjes': 'sub-met-vakjes',
    vakjes: 'sub-met-vakjes',
    facher: 'sub-met-vakjes',
    faecher: 'sub-met-vakjes',
    'mit-fachern': 'sub-met-vakjes',
    'mit-faecher': 'sub-met-vakjes',
    'sub-facher': 'sub-met-vakjes',
    'sub-faecher': 'sub-met-vakjes',
    'sub-mit-fachern': 'sub-met-vakjes',
    'sub-mit-faecher': 'sub-met-vakjes',
    'sub-met-vakjes': 'sub-met-vakjes',
    lekvrij: 'sub-lekvrij',
    leakvrij: 'sub-lekvrij',
    auslaufsicher: 'sub-lekvrij',
    'sub-auslaufsicher': 'sub-lekvrij',
    dicht: 'sub-lekvrij',
    leakproof: 'sub-lekvrij',
    waterdicht: 'sub-lekvrij',
    'sub-lekvrij': 'sub-lekvrij',
    groot: 'sub-groot',
    grote: 'sub-groot',
    gross: 'sub-groot',
    grosse: 'sub-groot',
    large: 'sub-groot',
    xl: 'sub-groot',
    'sub-gross': 'sub-groot',
    'sub-grosse': 'sub-groot',
    'sub-large': 'sub-groot',
    'sub-xl': 'sub-groot',
    'sub-groot': 'sub-groot',
    kinderen: 'sub-kinderen',
    kinder: 'sub-kinderen',
    kids: 'sub-kinderen',
    children: 'sub-kinderen',
    'sub-kinder': 'sub-kinderen',
    'sub-kids': 'sub-kinderen',
    'sub-children': 'sub-kinderen',
    'sub-kinderen': 'sub-kinderen',
    kinderborden: 'sub-kinderborden',
    kinderteller: 'sub-kinderborden',
    'sub-kinderteller': 'sub-kinderborden',
    'sub-kinderborden': 'sub-kinderborden',
    klein: 'sub-klein',
    kleine: 'sub-klein',
    small: 'sub-klein',
    'sub-small': 'sub-klein',
    'sub-klein': 'sub-klein',
    rond: 'sub-rond',
    ronde: 'sub-rond',
    rund: 'sub-rond',
    runde: 'sub-rond',
    round: 'sub-rond',
    'sub-rund': 'sub-rond',
    'sub-runde': 'sub-rond',
    'sub-round': 'sub-rond',
    'sub-rond': 'sub-rond',
    maaltijdborden: 'sub-maaltijdborden',
    maaltijd: 'sub-maaltijdborden',
    speiseteller: 'sub-maaltijdborden',
    essteller: 'sub-maaltijdborden',
    'sub-speiseteller': 'sub-maaltijdborden',
    'sub-essteller': 'sub-maaltijdborden',
    'sub-maaltijdborden': 'sub-maaltijdborden',
    thali: 'sub-thali',
    'thali-borden': 'sub-thali',
    'sub-thali': 'sub-thali',
    koffie: 'sub-koffie',
    kaffee: 'sub-koffie',
    coffee: 'sub-koffie',
    'sub-kaffee': 'sub-koffie',
    'sub-coffee': 'sub-koffie',
    'sub-koffie': 'sub-koffie',
    drinkbeker: 'sub-beker',
    beker: 'sub-beker',
    becher: 'sub-beker',
    cup: 'sub-beker',
    trinkbecher: 'sub-beker',
    'sub-drinkbeker': 'sub-beker',
    'sub-trinkbecher': 'sub-beker',
    'sub-becher': 'sub-beker',
    'sub-cup': 'sub-beker',
    'sub-beker': 'sub-beker',
    refined: 'refined',
    'sub-refined': 'sub-refined'
  };

  function resolveSubcategoryTag(tag, label, categoryTag) {
    var normalizedTag = normalizeHandle(tag);
    var normalizedLabel = normalizeHandle(label);
    if (
      normalizedTag === 'all' ||
      normalizedTag.indexOf('all-') === 0 ||
      normalizedLabel === 'all' ||
      normalizedLabel.indexOf('all-') === 0 ||
      normalizedLabel === 'alle' ||
      normalizedLabel.indexOf('alle-') === 0
    ) {
      return 'all';
    }

    if (subcategoryCanonicalTags[normalizedTag]) {
      var canonicalTag = subcategoryCanonicalTags[normalizedTag];
      if (canonicalTag === 'sub-kinderen' && categoryTag === 'borden') return 'sub-kinderborden';
      if (canonicalTag === 'refined' && categoryTag === 'borden') return 'sub-refined';
      return canonicalTag;
    }

    if (normalizedTag.indexOf('sub-') === 0) {
      return normalizedTag;
    }

    var basis = [
      normalizedTag,
      normalizedLabel
    ].join('-');

    if (containsAny(basis, ['3-in-1', '3in1'])) return 'sub-3-in-1';
    if (containsAny(basis, ['set-van-2', '2er-set', 'set-of-2', 'set-2'])) return 'sub-set-van-2';
    if (containsAny(basis, ['met-vakjes', 'vakjes', 'facher', 'faecher', 'compartment', 'compartments', 'divided'])) return 'sub-met-vakjes';
    if (containsAny(basis, ['lekvrij', 'leakvrij', 'auslaufsicher', 'dicht', 'leakproof'])) return 'sub-lekvrij';
    if (containsAny(basis, ['groot', 'grote', 'gross', 'grosse', 'large', 'xl'])) return 'sub-groot';
    if (containsAny(basis, ['kinderen', 'kinder', 'kids', 'children'])) {
      return categoryTag === 'borden' ? 'sub-kinderborden' : 'sub-kinderen';
    }
    if (containsAny(basis, ['klein', 'kleine', 'small'])) return 'sub-klein';
    if (containsAny(basis, ['rond', 'rund', 'round'])) return 'sub-rond';
    if (containsAny(basis, ['maaltijdborden', 'maaltijd', 'speiseteller', 'mahlzeit', 'meal-plate', 'dinner-plate'])) return 'sub-maaltijdborden';
    if (containsAny(basis, ['thali'])) return 'sub-thali';
    if (containsAny(basis, ['koffie', 'kaffee', 'coffee'])) return 'sub-koffie';
    if (containsAny(basis, ['drinkbeker', 'beker', 'becher', 'cup'])) return 'sub-beker';
    if (containsAny(basis, ['refined'])) return categoryTag === 'borden' ? 'sub-refined' : 'refined';

    return normalizedTag;
  }

  var categoryTagAliases = {
    'rvs-lunchboxen': ['rvs-lunchboxen', 'lunchbox', 'lunchboxen', 'broodtrommel', 'broodtrommels', 'brotdose', 'brotdosen', 'brot-dose'],
    'rvs-snackboxen': ['rvs-snackboxen', 'snackbox', 'snackboxen', 'snackdoos', 'snackdozen', 'snack-dose'],
    borden: ['borden', 'bord', 'teller', 'tellers', 'plate', 'plates', 'schild', 'schilder'],
    'cat-bekers': ['cat-bekers', 'beker', 'bekers', 'mok', 'mokken', 'becher', 'tasse', 'tassen', 'cup', 'cups'],
    'cat-schalen': ['cat-schalen', 'schaal', 'schalen', 'schaaltjes', 'schussel', 'schuessel', 'schusseln', 'schuesseln', 'bowl', 'bowls'],
    stickers: ['stickers', 'sticker', 'aufkleber'],
    refined: ['refined', 'refined-collectie', 'veredelte-kollektion']
  };

  var categorySubcategories = {
    'rvs-lunchboxen': [
      { label: 'Alle lunchboxen', tag: 'all' },
      { label: 'Lekvrij', tag: 'sub-lekvrij' },
      { label: 'Groot', tag: 'sub-groot' },
      { label: 'Met vakjes', tag: 'sub-met-vakjes' },
      { label: 'Kinderen', tag: 'sub-kinderen' },
      { label: '3 in 1', tag: 'sub-3-in-1' }
    ],
    'rvs-snackboxen': [
      { label: 'Alle snackboxen', tag: 'all' },
      { label: 'Lekvrij', tag: 'sub-lekvrij' }
    ],
    borden: [
      { label: 'Alle borden', tag: 'all' },
      { label: 'Kinderborden', tag: 'sub-kinderborden' },
      { label: 'Maaltijdborden', tag: 'sub-maaltijdborden' },
      { label: 'Refined', tag: 'sub-refined' }
    ],
    'cat-bekers': [
      { label: 'Alle bekers', tag: 'all' },
      { label: 'Koffie', tag: 'sub-koffie' },
      { label: 'Drinkbekers', tag: 'sub-beker' },
      { label: 'Refined', tag: 'refined' }
    ]
  };

  function getCanonicalSubcategories(categoryTag, fallbackSubcategories) {
    var resolvedCategoryTag = resolveCategoryTag(categoryTag, '', '');
    var canonicalSubcategories = categorySubcategories[resolvedCategoryTag];
    var subcategories = fallbackSubcategories && fallbackSubcategories.length
      ? fallbackSubcategories
      : canonicalSubcategories;

    return subcategories || [];
  }

  function getCategoryTagAliases(tag) {
    var categoryTag = resolveCategoryTag(tag, '', '');
    var aliases = categoryTagAliases[categoryTag] || [categoryTag];

    return uniqueValues(aliases.concat([categoryTag, tag]).map(normalizeHandle));
  }

  function tagsIncludeAny(tags, aliases) {
    return aliases.some(function (alias) {
      return tags.indexOf(alias) !== -1;
    });
  }

  function tagsIncludeCategory(tags, categoryTag) {
    var resolvedCategoryTag = resolveCategoryTag(categoryTag, '', '');
    var aliases = getCategoryTagAliases(categoryTag);

    return tags.some(function (tag) {
      return aliases.indexOf(tag) !== -1 || resolveCategoryTag(tag, '', '') === resolvedCategoryTag;
    });
  }

  var subcategoryTagAliases = {
    'sub-3-in-1': ['sub-3-in-1', '3-in-1', '3in1'],
    'sub-set-van-2': ['sub-set-van-2', 'set-van-2', '2er-set', 'sub-2er-set', 'set-of-2', 'sub-set-of-2'],
    'sub-met-vakjes': ['sub-met-vakjes', 'met-vakjes', 'vakjes', 'facher', 'faecher', 'mit-fachern', 'sub-mit-fachern', 'sub-facher', 'sub-faecher'],
    'sub-lekvrij': ['sub-lekvrij', 'lekvrij', 'leakvrij', 'auslaufsicher', 'waterdicht'],
    'sub-groot': ['sub-groot', 'groot', 'grote', 'gross', 'sub-gross', 'xl', 'large'],
    'sub-kinderen': ['sub-kinderen', 'kinderen', 'kinder', 'sub-kinder', 'kids'],
    'sub-kinderborden': ['sub-kinderborden', 'kinderborden', 'kinderteller', 'sub-kinderteller'],
    'sub-klein': ['sub-klein', 'klein', 'small', 'sub-small'],
    'sub-rond': ['sub-rond', 'rond', 'ronde', 'rund', 'sub-rund', 'runde', 'round'],
    'sub-maaltijdborden': ['sub-maaltijdborden', 'maaltijdborden', 'speiseteller', 'sub-speiseteller', 'essteller', 'sub-essteller'],
    'sub-thali': ['sub-thali', 'thali', 'thali-borden'],
    'sub-koffie': ['sub-koffie', 'koffie', 'kaffee', 'sub-kaffee', 'coffee'],
    'sub-beker': ['sub-beker', 'drinkbeker', 'sub-drinkbeker', 'trinkbecher', 'sub-trinkbecher', 'becher', 'sub-becher', 'beker'],
    'sub-refined': ['sub-refined', 'refined'],
    refined: ['refined', 'sub-refined']
  };

  function getSubcategoryTagAliases(tag) {
    var normalizedTag = normalizeHandle(tag);
    var aliases = subcategoryTagAliases[normalizedTag] || [normalizedTag];

    return uniqueValues(aliases.concat([normalizedTag, tag]).map(normalizeHandle));
  }

  function tagsIncludeSubcategory(tags, subcategoryTag) {
    return tagsIncludeAny(tags, getSubcategoryTagAliases(subcategoryTag));
  }

  function asNumber(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function getOptionLabel(option) {
    var label = option.querySelector('span:last-child');
    return label ? label.textContent.trim() : option.textContent.trim();
  }

  function getCurrentUrl() {
    try {
      return new URL(window.location.href);
    } catch (error) {
      return null;
    }
  }

  function fromNativeSortValue(value) {
    if (value === 'best-selling') return value;
    if (value === 'price-ascending' || value === 'price-descending') return value;
    return '';
  }

  function toNativeSortValue(value) {
    if (value === 'best-selling') return value;
    if (value === 'price-ascending' || value === 'price-descending') return value;
    return '';
  }

  function getCollectionUrl(handle, sortValue, collectionUrl) {
    if (collectionUrl) {
      var localizedUrl = new URL(collectionUrl, window.location.origin);
      var localizedSortValue = toNativeSortValue(sortValue);

      if (localizedSortValue) {
        localizedUrl.searchParams.set('sort_by', localizedSortValue);
      }

      return localizedUrl.toString();
    }

    if (!handle) return '';

    var routesRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    var basePath = routesRoot.replace(/\/$/, '') + '/collections/' + encodeURIComponent(handle);
    var url = new URL(basePath, window.location.origin);
    var nativeSortValue = toNativeSortValue(sortValue);

    if (nativeSortValue) {
      url.searchParams.set('sort_by', nativeSortValue);
    }

    return url.toString();
  }

  function getInitialSort(root) {
    var currentUrl = getCurrentUrl();
    var sortBy = currentUrl ? fromNativeSortValue(currentUrl.searchParams.get('sort_by')) : '';
    return sortBy || root.dataset.defaultSort || 'featured';
  }

  function syncNativeSortVisibility() {
    var shouldHide = Array.prototype.some.call(document.querySelectorAll(rootSelector), function (root) {
      return root.dataset.hideNativeSort === 'true' && root.querySelector('[data-talli-sort]');
    });

    document.documentElement.classList.toggle('talli-hide-native-sort', shouldHide);
  }

  function TalliCollectionFilters(root) {
    this.root = root;
    this.gridContainer = document.getElementById('ProductGridContainer');
    this.grid = null;
    this.items = [];
    this.liquidAvailableTags = parseJson(root.dataset.availableTags, []);
    this.availableTagsByCollection = {};
    this.availableTags = this.liquidAvailableTags.slice();
    this.collectionAvailableTags = this.liquidAvailableTags.slice();
    this.categoryAvailableTags = this.liquidAvailableTags.slice();
    this.hideUnavailableOptions = root.dataset.hideUnavailableOptions !== 'false';
    this.initialSubcategories = parseJson(root.dataset.initialSubcategories, []);
    this.subcategoriesOnly = root.dataset.subcategoriesOnly === 'true';
    this.isAggregateCollection = root.dataset.aggregateCollection === 'true';
    this.baseCollectionHandle = root.dataset.currentCollectionHandle || '';
    this.activeCollectionHandle = this.baseCollectionHandle;
    this.baseCollectionUrl = root.dataset.currentCollectionUrl || '';
    this.activeCollectionUrl = this.baseCollectionUrl;
    if (this.baseCollectionHandle) this.availableTagsByCollection[this.baseCollectionHandle] = this.liquidAvailableTags.slice();
    this.collectionTagsPending = false;
    this.activeCategory = 'all';
    this.activeSubcategory = 'all';
    this.activeSort = getInitialSort(root);
    this.mutationObserver = null;
    this.pendingGridRequest = 0;
    this.isGridLoading = false;
    this.activeGridController = null;
    this.gridStateCache = {};

    this.normalizeConfiguredFilters();

    this.onClick = this.onClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onGridChanged = this.onGridChanged.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);

    this.root.addEventListener('click', this.onClick);
    this.root.addEventListener('keydown', this.onKeydown);
    this.root.addEventListener('scroll', this.onScroll, true);
    document.addEventListener('click', this.onDocumentClick);
    window.addEventListener('resize', this.onResize);

    if (this.gridContainer) {
      this.mutationObserver = new MutationObserver(this.onGridChanged);
      this.mutationObserver.observe(this.gridContainer, { childList: true, subtree: false });
    }

    syncNativeSortVisibility();
    this.syncAvailableCategoryButtons();
    this.prepareSubcategoriesOnly();
    this.restoreFiltersFromUrl();
    this.refresh();
    this.setSort(this.activeSort, false);

    if (this.activeCollectionHandle && this.activeCollectionHandle !== this.baseCollectionHandle) {
      this.loadGridForActiveState();
    }
  }

  TalliCollectionFilters.prototype.normalizeSubcategories = function (subcategories, categoryTag) {
    var normalized = [];
    var seenTags = [];
    var resolvedCategoryTag = resolveCategoryTag(categoryTag, '', '');
    var canonicalSubcategories = categorySubcategories[resolvedCategoryTag] || [];

    subcategories.forEach(function (subcategory, index) {
      if (!subcategory || !subcategory.label || !subcategory.tag) return;

      var canonicalSubcategory = canonicalSubcategories[index];
      var tag = canonicalSubcategory
        ? canonicalSubcategory.tag
        : resolveSubcategoryTag(subcategory.tag, subcategory.label, resolvedCategoryTag);
      if (!tag || seenTags.indexOf(tag) !== -1) return;

      seenTags.push(tag);
      normalized.push({
        label: subcategory.label,
        tag: tag
      });
    });

    return normalized;
  };

  TalliCollectionFilters.prototype.normalizeConfiguredFilters = function () {
    var buttons = Array.prototype.slice.call(this.root.querySelectorAll('[data-talli-category-button]'));

    buttons.forEach(function (button) {
      var categoryTag = resolveCategoryButtonTag(button);
      var subcategories = parseJson(button.dataset.talliSubcategories, []);

      button.dataset.talliCategoryTag = categoryTag;
      button.dataset.talliCollectionHandle = normalizeHandle(button.dataset.talliCollectionHandle);
      button.dataset.talliSubcategories = JSON.stringify(
        getCanonicalSubcategories(
          categoryTag,
          this.normalizeSubcategories(subcategories, categoryTag)
        )
      );
    }, this);

    var initialCategoryTag = resolveCategoryTag(this.root.dataset.initialCategoryTag, '', this.baseCollectionHandle);
    this.initialSubcategories = this.normalizeSubcategories(
      this.initialSubcategories,
      initialCategoryTag
    );
    this.initialSubcategories = getCanonicalSubcategories(initialCategoryTag, this.initialSubcategories);

    if (this.root.dataset.initialCategoryTag) {
      this.root.dataset.initialCategoryTag = resolveCategoryTag(
        this.root.dataset.initialCategoryTag,
        '',
        this.baseCollectionHandle
      );
    }
  };

  TalliCollectionFilters.prototype.destroy = function () {
    this.root.removeEventListener('click', this.onClick);
    this.root.removeEventListener('keydown', this.onKeydown);
    this.root.removeEventListener('scroll', this.onScroll, true);
    document.removeEventListener('click', this.onDocumentClick);
    window.removeEventListener('resize', this.onResize);

    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }

    this.setLoading(false);
    syncNativeSortVisibility();
  };

  TalliCollectionFilters.prototype.refresh = function () {
    this.grid = document.getElementById('product-grid');
    this.items = this.grid ? Array.prototype.slice.call(this.grid.querySelectorAll(itemSelector)) : [];
    this.syncAvailableTagsFromItems();
    this.syncAvailableCategoryButtons();

    if (this.subcategoriesOnly) {
      this.renderSubcategories(this.getInitialSubcategories());
      this.syncSubcategoryButtons();
    } else {
      this.syncActiveCategorySubcategories();
    }

    this.apply();
    this.syncScrollFades();
  };

  TalliCollectionFilters.prototype.onGridChanged = function () {
    this.refresh();
  };

  TalliCollectionFilters.prototype.onScroll = function (event) {
    if (event.target && event.target.classList && event.target.classList.contains('talli-filter-row')) {
      this.syncScrollFades();
    }
  };

  TalliCollectionFilters.prototype.onResize = function () {
    this.syncScrollFades();
  };

  TalliCollectionFilters.prototype.setLoading = function (isLoading) {
    this.isGridLoading = isLoading;
    this.root.classList.toggle('is-talli-loading', isLoading);

    if (this.gridContainer) {
      this.gridContainer.classList.toggle('talli-grid-loading', isLoading);
    }

    if (!isLoading) return;

    var emptyState = this.root.querySelector('[data-talli-empty]');
    var count = this.root.querySelector('[data-talli-count]');
    if (emptyState) {
      emptyState.hidden = true;
      emptyState.setAttribute('aria-hidden', 'true');
      emptyState.textContent = '';
    }
    if (count) count.hidden = true;
  };

  TalliCollectionFilters.prototype.hideNativeEmptyState = function () {
    if (!this.gridContainer) return;

    var nativeEmptyState = this.gridContainer.querySelector('.collection--empty');
    if (!nativeEmptyState) return;

    nativeEmptyState.hidden = true;
    nativeEmptyState.setAttribute('aria-hidden', 'true');
  };

  TalliCollectionFilters.prototype.usesLinkedCollection = function () {
    if (this.isAggregateCollection) return false;

    return !this.subcategoriesOnly &&
      this.activeCategory !== 'all' &&
      this.activeCollectionHandle &&
      this.activeCollectionHandle !== this.baseCollectionHandle;
  };

  TalliCollectionFilters.prototype.onClick = function (event) {
    var categoryButton = event.target.closest('[data-talli-category-button]');
    var subcategoryButton = event.target.closest('[data-talli-subcategory-button]');
    var sortToggle = event.target.closest('[data-talli-sort-toggle]');
    var sortOption = event.target.closest('[data-talli-sort-option]');

    if (categoryButton && this.root.contains(categoryButton)) {
      event.preventDefault();
      event.stopPropagation();
      this.selectCategory(categoryButton);
      return;
    }

    if (subcategoryButton && this.root.contains(subcategoryButton)) {
      event.preventDefault();
      event.stopPropagation();
      this.selectSubcategory(subcategoryButton);
      return;
    }

    if (sortToggle && this.root.contains(sortToggle)) {
      event.preventDefault();
      event.stopPropagation();
      this.toggleSortMenu();
      return;
    }

    if (sortOption && this.root.contains(sortOption)) {
      event.preventDefault();
      event.stopPropagation();
      this.setSort(sortOption.dataset.talliSortValue || 'featured', true);
      this.closeSortMenu();
    }
  };

  TalliCollectionFilters.prototype.onKeydown = function (event) {
    var sortMenu = this.root.querySelector('[data-talli-sort-menu]');
    var sortToggle = this.root.querySelector('[data-talli-sort-toggle]');
    var sortOptions = Array.prototype.slice.call(this.root.querySelectorAll('[data-talli-sort-option]:not([hidden])'));
    var activeElement = document.activeElement;

    if (event.key === 'Escape') {
      this.closeSortMenu();
      if (sortToggle && this.root.contains(activeElement)) sortToggle.focus();
      return;
    }

    if (!sortMenu || sortMenu.hidden) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();

      if (activeElement === sortToggle) {
        if (sortOptions[0]) sortOptions[0].focus();
        return;
      }

      var nextIndex = sortOptions.indexOf(activeElement) + 1;
      if (sortOptions[nextIndex]) {
        sortOptions[nextIndex].focus();
      } else if (sortOptions[0]) {
        sortOptions[0].focus();
      }
    }

    if (event.key === 'ArrowUp') {
      event.preventDefault();
      var previousIndex = sortOptions.indexOf(activeElement) - 1;

      if (sortOptions[previousIndex]) {
        sortOptions[previousIndex].focus();
      } else if (sortOptions[sortOptions.length - 1]) {
        sortOptions[sortOptions.length - 1].focus();
      }
    }
  };

  TalliCollectionFilters.prototype.onDocumentClick = function (event) {
    var sort = event.target.closest('[data-talli-sort]');

    if (!sort || !this.root.contains(sort)) {
      this.closeSortMenu();
    }
  };

  TalliCollectionFilters.prototype.selectCategory = function (button) {
    if (this.subcategoriesOnly) return;

    this.closeSortMenu();

    var buttons = this.root.querySelectorAll('[data-talli-category-button]');
    buttons.forEach(function (item) {
      var isActive = item === button;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    this.activeCategory = button.dataset.talliCategoryTag || 'all';
    if (this.isAggregateCollection) {
      this.activeCollectionHandle = this.baseCollectionHandle;
      this.activeCollectionUrl = this.baseCollectionUrl;
    } else {
      this.activeCollectionHandle = button.dataset.talliCollectionHandle || this.baseCollectionHandle;
      this.activeCollectionUrl = button.dataset.talliCollectionUrl || '';
    }
    this.setLoading(true);
    if (this.availableTagsByCollection[this.activeCollectionHandle]) {
      this.collectionAvailableTags = this.availableTagsByCollection[this.activeCollectionHandle].slice();
      this.availableTags = this.collectionAvailableTags.slice();
      this.collectionTagsPending = false;
    } else {
      this.collectionTagsPending = this.activeCollectionHandle && this.activeCollectionHandle !== this.baseCollectionHandle;
    }
    this.activeSubcategory = 'all';
    this.syncActiveCategorySubcategories();
    this.updateFilterUrl();
    this.scrollButtonOutOfFade(button);
    this.loadGridForActiveState();
  };

  TalliCollectionFilters.prototype.hasAvailableTag = function (tag) {
    if (tag === 'all') return true;
    if (this.collectionTagsPending) return false;
    if (!this.hideUnavailableOptions) return true;
    if (this.availableTags.length && tagsIncludeSubcategory(this.availableTags, tag)) return true;
    if (!this.availableTags.length && !this.items.length) return true;

    return this.items.some(function (item) {
      return this.itemMatchesSubcategory(item, tag);
    }, this);
  };

  TalliCollectionFilters.prototype.hasAvailableCategoryTag = function (tag) {
    if (tag === 'all') return true;
    if (!this.hideUnavailableOptions) return true;
    if (!this.categoryAvailableTags.length) return true;
    return tagsIncludeCategory(this.categoryAvailableTags, tag);
  };

  TalliCollectionFilters.prototype.syncAvailableTagsFromItems = function () {
    var tags = this.collectionAvailableTags.slice();
    if (!this.items.length) {
      this.availableTags = uniqueValues(tags);
      if (this.activeCollectionHandle === this.baseCollectionHandle) {
        this.categoryAvailableTags = this.availableTags.slice();
      }
      return;
    }

    this.items.forEach(function (item) {
      tags = tags.concat(this.getItemTags(item));
    }, this);

    this.availableTags = uniqueValues(tags);
    if (this.activeCollectionHandle === this.baseCollectionHandle) {
      this.categoryAvailableTags = this.availableTags.slice();
    }
  };

  TalliCollectionFilters.prototype.getVisibleSubcategories = function (subcategories) {
    var visibleSubcategories = [];
    var allSubcategory = null;

    subcategories.forEach(function (subcategory) {
      if (!subcategory || !subcategory.label || !subcategory.tag) return;

      if (subcategory.tag === 'all') {
        if (!allSubcategory) allSubcategory = subcategory;
        return;
      }

      if (this.hasAvailableTag(subcategory.tag)) {
        visibleSubcategories.push(subcategory);
      }
    }, this);

    if (visibleSubcategories.length && allSubcategory) {
      visibleSubcategories.unshift(allSubcategory);
    }

    return visibleSubcategories;
  };

  TalliCollectionFilters.prototype.syncAvailableCategoryButtons = function () {
    var row = this.root.querySelector('.talli-filter-row--main');
    if (!row) return;

    if (this.subcategoriesOnly) {
      row.hidden = true;
      return;
    }

    var buttons = Array.prototype.slice.call(this.root.querySelectorAll('[data-talli-category-button]'));
    var configuredCategoryCount = 0;
    var visibleCategoryCount = 0;
    var activeButtonWasHidden = false;

    buttons.forEach(function (button) {
      var tag = button.dataset.talliCategoryTag || 'all';
      if (tag === 'all') {
        button.hidden = false;
        return;
      }

      configuredCategoryCount += 1;
      var isVisible = this.hasAvailableCategoryTag(tag);
      button.hidden = !isVisible;
      if (isVisible) visibleCategoryCount += 1;

      if (!isVisible && button.classList.contains('is-active')) {
        activeButtonWasHidden = true;
      }
    }, this);

    if (visibleCategoryCount === 0 && configuredCategoryCount > 0) {
      buttons.forEach(function (button) {
        var tag = button.dataset.talliCategoryTag || 'all';
        if (tag !== 'all') button.hidden = false;
      });
      visibleCategoryCount = configuredCategoryCount;
      activeButtonWasHidden = false;
    }

    if (activeButtonWasHidden) {
      var allButton = this.root.querySelector('[data-talli-category-button][data-talli-category-tag="all"]');
      if (allButton) this.selectCategory(allButton);
    }

    row.hidden = visibleCategoryCount === 0;
  };

  TalliCollectionFilters.prototype.getInitialSubcategories = function () {
    if (this.initialSubcategories.length) return this.initialSubcategories;

    var categoryButtons = Array.prototype.slice.call(this.root.querySelectorAll('[data-talli-category-button]'));

    for (var index = 0; index < categoryButtons.length; index += 1) {
      var button = categoryButtons[index];
      var tag = button.dataset.talliCategoryTag || 'all';
      if (tag === 'all') continue;

      var subcategories = parseJson(button.dataset.talliSubcategories, []);
      if (subcategories.length) return subcategories;
    }

    return [];
  };

  TalliCollectionFilters.prototype.getActiveCategoryButton = function () {
    if (!this.activeCategory || this.activeCategory === 'all') return null;

    return Array.prototype.slice.call(this.root.querySelectorAll('[data-talli-category-button]')).find(function (button) {
      return (button.dataset.talliCategoryTag || 'all') === this.activeCategory;
    }, this) || null;
  };

  TalliCollectionFilters.prototype.syncActiveCategorySubcategories = function () {
    var activeButton = this.getActiveCategoryButton();

    if (!activeButton) {
      this.renderSubcategories([]);
      return;
    }

    var subcategories = parseJson(activeButton.dataset.talliSubcategories, []);

    if (this.collectionTagsPending) {
      this.renderPendingSubcategories(subcategories);
      return;
    }

    this.renderSubcategories(subcategories);
    this.syncSubcategoryButtons();
  };

  TalliCollectionFilters.prototype.renderPendingSubcategories = function (subcategories) {
    var row = this.root.querySelector('[data-talli-subcategory-row]');
    if (!row) return;

    var hasConfiguredSubcategories = subcategories.some(function (subcategory) {
      return subcategory && subcategory.tag && subcategory.tag !== 'all';
    });
    var shouldReserveSpace = hasConfiguredSubcategories || !row.hidden;

    row.innerHTML = '';
    row.classList.toggle('is-loading', shouldReserveSpace);
    row.setAttribute('aria-busy', shouldReserveSpace ? 'true' : 'false');
    row.hidden = !shouldReserveSpace;
    this.syncScrollFades();
  };

  TalliCollectionFilters.prototype.syncScrollFades = function () {
    var wrappers = Array.prototype.slice.call(this.root.querySelectorAll('.talli-filter-row-wrap'));

    wrappers.forEach(function (wrapper) {
      var row = wrapper.querySelector('.talli-filter-row');
      if (!row || row.hidden) {
        wrapper.classList.remove('has-scroll-fade', 'is-scroll-at-end');
        return;
      }

      var hasOverflow = row.scrollWidth > row.clientWidth + 2;
      var isAtEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;

      wrapper.classList.toggle('has-scroll-fade', hasOverflow);
      wrapper.classList.toggle('is-scroll-at-end', hasOverflow && isAtEnd);
    });
  };

  TalliCollectionFilters.prototype.scrollButtonOutOfFade = function (button) {
    var row = button ? button.closest('.talli-filter-row') : null;
    if (!row || row.scrollWidth <= row.clientWidth + 2) return;

    var rowRect = row.getBoundingClientRect();
    var buttonRect = button.getBoundingClientRect();
    var fadeWidth = parseFloat(window.getComputedStyle(this.root).getPropertyValue('--talli-fade-width')) || 26;
    var buffer = 8;
    var leftOverflow = buttonRect.left - rowRect.left;
    var rightOverflow = buttonRect.right - (rowRect.right - fadeWidth);
    var scrollBy = 0;

    if (rightOverflow > 0) {
      scrollBy = rightOverflow + buffer;
    } else if (leftOverflow < 0) {
      scrollBy = leftOverflow - buffer;
    }

    if (!scrollBy) return;

    row.scrollBy({ left: scrollBy, behavior: 'smooth' });
    window.setTimeout(this.syncScrollFades.bind(this), 260);
  };

  TalliCollectionFilters.prototype.prepareSubcategoriesOnly = function () {
    if (!this.subcategoriesOnly) return;

    this.activeCategory = 'all';
    this.activeCollectionHandle = this.baseCollectionHandle;
    this.activeCollectionUrl = this.baseCollectionUrl;
    this.collectionAvailableTags = this.liquidAvailableTags.slice();
    this.collectionTagsPending = false;
    this.activeSubcategory = 'all';
    this.renderSubcategories(this.getInitialSubcategories());
  };

  TalliCollectionFilters.prototype.restoreFiltersFromUrl = function () {
    var currentUrl = getCurrentUrl();
    if (!currentUrl) return;

    var category = resolveCategoryTag(currentUrl.searchParams.get('talli_category') || 'all', '', '');
    var subcategory = resolveSubcategoryTag(currentUrl.searchParams.get('talli_subcategory') || 'all', '', category);

    if (this.subcategoriesOnly) {
      this.activeCollectionHandle = this.baseCollectionHandle;
      this.activeCollectionUrl = this.baseCollectionUrl;
      this.collectionAvailableTags = this.liquidAvailableTags.slice();
      this.collectionTagsPending = false;
      this.activeSubcategory = subcategory;
      this.syncSubcategoryButtons();
      return;
    }

    if (category === 'all') return;

    if (!this.hasAvailableCategoryTag(category)) return;

    var categoryButtons = Array.prototype.slice.call(this.root.querySelectorAll('[data-talli-category-button]'));
    var button = categoryButtons.find(function (item) {
      return (item.dataset.talliCategoryTag || 'all') === category && !item.hidden;
    });

    if (!button) return;

    categoryButtons.forEach(function (item) {
      var isActive = item === button;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    this.activeCategory = category;
    if (this.isAggregateCollection) {
      this.activeCollectionHandle = this.baseCollectionHandle;
      this.activeCollectionUrl = this.baseCollectionUrl;
    } else {
      this.activeCollectionHandle = button.dataset.talliCollectionHandle || this.baseCollectionHandle;
      this.activeCollectionUrl = button.dataset.talliCollectionUrl || '';
    }
    if (this.availableTagsByCollection[this.activeCollectionHandle]) {
      this.collectionAvailableTags = this.availableTagsByCollection[this.activeCollectionHandle].slice();
      this.availableTags = this.collectionAvailableTags.slice();
      this.collectionTagsPending = false;
    } else {
      this.collectionTagsPending = this.activeCollectionHandle && this.activeCollectionHandle !== this.baseCollectionHandle;
    }
    this.activeSubcategory = subcategory;
    this.syncActiveCategorySubcategories();
  };

  TalliCollectionFilters.prototype.renderSubcategories = function (subcategories) {
    var row = this.root.querySelector('[data-talli-subcategory-row]');
    if (!row) return;

    row.innerHTML = '';
    row.classList.remove('is-loading');
    row.removeAttribute('aria-busy');

    var visibleSubcategories = this.getVisibleSubcategories(subcategories);

    if (!visibleSubcategories.length || (this.activeCategory === 'all' && !this.subcategoriesOnly)) {
      row.hidden = true;
      this.syncScrollFades();
      return;
    }

    var activeSubcategoryExists = visibleSubcategories.some(function (subcategory) {
      return subcategory.tag === this.activeSubcategory;
    }, this);

    if (!activeSubcategoryExists) {
      this.activeSubcategory = 'all';
    }

    visibleSubcategories.forEach(function (subcategory) {
      if (!subcategory || !subcategory.label || !subcategory.tag) return;

      var button = document.createElement('button');
      var isActive = subcategory.tag === 'all';
      button.type = 'button';
      button.className = 'talli-filter-button talli-filter-button--sub';
      button.dataset.talliSubcategoryButton = '';
      button.dataset.talliSubcategoryTag = subcategory.tag;
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      button.textContent = subcategory.label;

      if (isActive && this.activeSubcategory === 'all') {
        button.classList.add('is-active');
      }

      row.appendChild(button);
    }, this);

    row.hidden = row.children.length === 0;
    this.syncScrollFades();
  };

  TalliCollectionFilters.prototype.syncSubcategoryButtons = function () {
    var buttons = Array.prototype.slice.call(this.root.querySelectorAll('[data-talli-subcategory-button]'));
    if (!buttons.length) return;

    var desiredTag = this.activeSubcategory || 'all';
    var hasDesiredTag = buttons.some(function (button) {
      return (button.dataset.talliSubcategoryTag || 'all') === desiredTag;
    });

    if (!hasDesiredTag) {
      desiredTag = 'all';
      this.activeSubcategory = 'all';
    }

    buttons.forEach(function (button) {
      var isActive = (button.dataset.talliSubcategoryTag || 'all') === desiredTag;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  };

  TalliCollectionFilters.prototype.selectSubcategory = function (button) {
    this.closeSortMenu();

    var buttons = this.root.querySelectorAll('[data-talli-subcategory-button]');
    buttons.forEach(function (item) {
      var isActive = item === button;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    this.activeSubcategory = button.dataset.talliSubcategoryTag || 'all';
    this.updateFilterUrl();
    this.scrollButtonOutOfFade(button);
    this.apply();
  };

  TalliCollectionFilters.prototype.writeFilterParams = function (searchParams) {
    if (!this.subcategoriesOnly && this.activeCategory && this.activeCategory !== 'all') {
      searchParams.set('talli_category', this.activeCategory);
    } else {
      searchParams.delete('talli_category');
    }

    if (this.activeSubcategory && this.activeSubcategory !== 'all') {
      searchParams.set('talli_subcategory', this.activeSubcategory);
    } else {
      searchParams.delete('talli_subcategory');
    }
  };

  TalliCollectionFilters.prototype.updateFilterUrl = function () {
    var currentUrl = getCurrentUrl();
    if (!currentUrl || !window.history || !window.history.replaceState) return;

    this.writeFilterParams(currentUrl.searchParams);
    window.history.replaceState({}, '', currentUrl.toString());
  };

  TalliCollectionFilters.prototype.getItemTags = function (item) {
    return parseJson(item.dataset.talliTags, []);
  };

  TalliCollectionFilters.prototype.itemMatchesSubcategory = function (item, subcategoryTag) {
    if (!subcategoryTag || subcategoryTag === 'all') return true;

    return tagsIncludeSubcategory(this.getItemTags(item), subcategoryTag);
  };

  TalliCollectionFilters.prototype.itemMatchesFilters = function (item) {
    if (this.subcategoriesOnly) {
      if (this.activeSubcategory && this.activeSubcategory !== 'all') {
        return this.itemMatchesSubcategory(item, this.activeSubcategory);
      }

      return true;
    }

    if (this.activeCategory === 'all') return true;

    var tags = this.getItemTags(item);

    if (this.usesLinkedCollection()) {
      if (this.activeSubcategory && this.activeSubcategory !== 'all') {
        return this.itemMatchesSubcategory(item, this.activeSubcategory);
      }

      return true;
    }

    var hasCategory = tagsIncludeCategory(tags, this.activeCategory);
    if (!hasCategory) return false;

    if (this.activeSubcategory && this.activeSubcategory !== 'all') {
      return this.itemMatchesSubcategory(item, this.activeSubcategory);
    }

    return true;
  };

  TalliCollectionFilters.prototype.getSortedItems = function () {
    var items = this.items.slice();

    // Client-side sorting only works on the products that are loaded on the current page.
    items.sort(function (first, second) {
      var firstIndex = asNumber(first.dataset.talliIndex, 0);
      var secondIndex = asNumber(second.dataset.talliIndex, 0);

      if (this.activeSort === 'price-ascending') {
        return asNumber(first.dataset.talliPrice, 0) - asNumber(second.dataset.talliPrice, 0) || firstIndex - secondIndex;
      }

      if (this.activeSort === 'price-descending') {
        return asNumber(second.dataset.talliPrice, 0) - asNumber(first.dataset.talliPrice, 0) || firstIndex - secondIndex;
      }

      return firstIndex - secondIndex;
    }, this);

    return items;
  };

  TalliCollectionFilters.prototype.apply = function () {
    if (!this.grid || !this.items.length) {
      this.hideNativeEmptyState();
      this.updateCount(0);
      this.updateEmptyState(0);
      return;
    }

    var sortedItems = this.getSortedItems();
    var visibleCount = 0;

    sortedItems.forEach(function (item, sortIndex) {
      var isVisible = this.itemMatchesFilters(item);
      item.style.order = sortIndex;
      item.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
      this.grid.appendChild(item);
    }, this);

    this.updateCount(visibleCount);
    this.updateEmptyState(visibleCount);
  };

  TalliCollectionFilters.prototype.updateCount = function (visibleCount) {
    var count = this.root.querySelector('[data-talli-count]');
    if (!count) return;

    var hasActiveFilter = this.activeCategory !== 'all' || (this.activeSubcategory && this.activeSubcategory !== 'all');

    if (this.isGridLoading || this.collectionTagsPending || this.root.dataset.showCount !== 'true' || (!hasActiveFilter && this.root.dataset.alwaysShowCount !== 'true')) {
      count.hidden = true;
      return;
    }

    count.textContent = this.root.dataset.countTemplate
      ? this.root.dataset.countTemplate.replace('__COUNT__', visibleCount)
      : visibleCount + ' producten gevonden';
    count.hidden = false;
  };

  TalliCollectionFilters.prototype.updateEmptyState = function (visibleCount) {
    var emptyState = this.root.querySelector('[data-talli-empty]');
    if (!emptyState) return;

    if (this.isGridLoading || this.collectionTagsPending) {
      emptyState.hidden = true;
      emptyState.setAttribute('aria-hidden', 'true');
      emptyState.textContent = '';
      return;
    }

    var isEmpty = visibleCount === 0;
    emptyState.hidden = !isEmpty;
    emptyState.setAttribute('aria-hidden', isEmpty ? 'false' : 'true');
    emptyState.textContent = isEmpty ? (emptyState.dataset.talliEmptyText || '') : '';
  };

  TalliCollectionFilters.prototype.toggleSortMenu = function () {
    var menu = this.root.querySelector('[data-talli-sort-menu]');
    var toggle = this.root.querySelector('[data-talli-sort-toggle]');
    if (!menu || !toggle) return;

    var willOpen = menu.hidden;
    menu.hidden = !willOpen;
    toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    this.root.classList.toggle('is-sort-open', willOpen);
  };

  TalliCollectionFilters.prototype.closeSortMenu = function () {
    var menu = this.root.querySelector('[data-talli-sort-menu]');
    var toggle = this.root.querySelector('[data-talli-sort-toggle]');
    if (!menu || !toggle) return;

    menu.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    this.root.classList.remove('is-sort-open');
  };

  TalliCollectionFilters.prototype.setSort = function (sortValue, shouldApply) {
    var options = this.root.querySelectorAll('[data-talli-sort-option]');
    var activeOption = null;

    options.forEach(function (option) {
      var isActive = option.dataset.talliSortValue === sortValue && !option.hidden;
      option.setAttribute('aria-checked', isActive ? 'true' : 'false');
      if (isActive) activeOption = option;
    });

    if (!activeOption) {
      activeOption = this.root.querySelector('[data-talli-sort-option][data-talli-sort-value="featured"]');
      sortValue = 'featured';
      if (activeOption) activeOption.setAttribute('aria-checked', 'true');
    }

    this.activeSort = sortValue;

    var current = this.root.querySelector('[data-talli-sort-current]');
    if (current && activeOption) {
      current.textContent = getOptionLabel(activeOption);
    }

    if (shouldApply !== false) {
      this.setLoading(true);
      this.updateSortUrl(sortValue);
      this.loadGridForActiveState();
    }
  };

  TalliCollectionFilters.prototype.updateSortUrl = function (sortValue) {
    var currentUrl = getCurrentUrl();
    if (!currentUrl) return;

    var nativeSortValue = toNativeSortValue(sortValue);
    if (nativeSortValue) {
      currentUrl.searchParams.set('sort_by', nativeSortValue);
    } else {
      currentUrl.searchParams.delete('sort_by');
    }

    this.writeFilterParams(currentUrl.searchParams);
    window.history.replaceState({}, '', currentUrl.toString());
  };

  TalliCollectionFilters.prototype.getGridCacheKey = function (collectionHandle, sortValue, collectionUrl) {
    return [collectionHandle || '', collectionUrl || '', sortValue || 'featured'].join('::');
  };

  TalliCollectionFilters.prototype.getProductGridSectionId = function () {
    var productGrid = this.gridContainer ? this.gridContainer.querySelector('[data-id]') : null;
    return productGrid ? productGrid.dataset.id || '' : '';
  };

  TalliCollectionFilters.prototype.getGridRequestUrl = function (collectionHandle, sortValue) {
    var requestUrl = getCollectionUrl(collectionHandle, sortValue, this.activeCollectionUrl);
    var sectionId = this.getProductGridSectionId();

    if (requestUrl && sectionId) {
      var url = new URL(requestUrl);
      url.searchParams.set('section_id', sectionId);
      return url.toString();
    }

    return requestUrl;
  };

  TalliCollectionFilters.prototype.extractAvailableTags = function (container) {
    var tags = [];
    var items = container ? Array.prototype.slice.call(container.querySelectorAll(itemSelector)) : [];

    items.forEach(function (item) {
      tags = tags.concat(this.getItemTags(item));
    }, this);

    return uniqueValues(tags);
  };

  TalliCollectionFilters.prototype.fetchGridState = function (collectionHandle, sortValue, controller) {
    var requestUrl = this.getGridRequestUrl(collectionHandle, sortValue);
    var fallbackUrl = getCollectionUrl(collectionHandle, sortValue, this.activeCollectionUrl);
    if (!requestUrl || !window.fetch || !window.DOMParser) {
      return Promise.reject(new Error('Grid request unavailable'));
    }

    var fetchHtml = function (url) {
      return fetch(url, {
        credentials: 'same-origin',
        signal: controller ? controller.signal : undefined
      }).then(function (response) {
        if (!response.ok) throw new Error('Grid request failed');
        return response.text();
      });
    };

    var parseGridHtml = function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nextGridContainer = doc.getElementById('ProductGridContainer');
      if (!nextGridContainer) throw new Error('Product grid not found');

      var nextRoot = doc.querySelector(rootSelector);
      var nextAvailableTags = nextRoot
        ? parseJson(nextRoot.dataset.availableTags, [])
        : this.extractAvailableTags(nextGridContainer);
      var data = {
        html: nextGridContainer.innerHTML,
        availableTags: nextAvailableTags
      };

      if (collectionHandle) {
        this.availableTagsByCollection[collectionHandle] = nextAvailableTags.slice();
      }
      return data;
    }.bind(this);

    return fetchHtml(requestUrl)
      .then(parseGridHtml)
      .catch(function (error) {
        if (requestUrl !== fallbackUrl && error && error.message === 'Product grid not found') {
          return fetchHtml(fallbackUrl).then(parseGridHtml);
        }

        throw error;
      });
  };

  TalliCollectionFilters.prototype.loadGridForActiveState = function () {
    var collectionHandle = this.activeCollectionHandle || this.baseCollectionHandle;
    var cacheKey = this.getGridCacheKey(collectionHandle, this.activeSort, this.activeCollectionUrl);
    var cachedState = this.gridStateCache[cacheKey];

    if (!this.gridContainer || !window.fetch || !window.DOMParser) {
      this.apply();
      return;
    }

    var requestId = this.pendingGridRequest + 1;
    this.pendingGridRequest = requestId;
    if (this.activeGridController) this.activeGridController.abort();
    this.activeGridController = 'AbortController' in window ? new AbortController() : null;

    if (cachedState) {
      this.applyGridState(cachedState, collectionHandle);
      return;
    }

    this.setLoading(true);

    this.fetchGridState(collectionHandle, this.activeSort, this.activeGridController)
      .then(function (data) {
        if (requestId !== this.pendingGridRequest) return;

        this.collectionAvailableTags = data.availableTags.slice();
        if (collectionHandle) {
          this.availableTagsByCollection[collectionHandle] = data.availableTags.slice();
        }
        this.collectionTagsPending = false;
        this.gridStateCache[cacheKey] = {
          html: data.html,
          availableTags: data.availableTags.slice()
        };
        this.applyGridState(data, collectionHandle);
      }.bind(this))
      .catch(function (error) {
        if (requestId === this.pendingGridRequest) {
          if (error && error.name === 'AbortError') return;

          this.collectionTagsPending = false;
          this.activeCollectionHandle = this.baseCollectionHandle;
          this.activeCollectionUrl = this.baseCollectionUrl;
          this.setLoading(false);
          this.syncActiveCategorySubcategories();
          this.apply();
        }
      }.bind(this))
      .finally(function () {
        if (requestId === this.pendingGridRequest) {
          this.setLoading(false);
        }
      }.bind(this));
  };

  TalliCollectionFilters.prototype.applyGridState = function (data, collectionHandle) {
    this.collectionAvailableTags = data.availableTags.slice();
    if (collectionHandle) {
      this.availableTagsByCollection[collectionHandle] = data.availableTags.slice();
    }
    this.collectionTagsPending = false;

    if (this.mutationObserver) this.mutationObserver.disconnect();
    this.gridContainer.innerHTML = data.html;
    if (this.mutationObserver) {
      this.mutationObserver.observe(this.gridContainer, { childList: true, subtree: false });
    }

    this.setLoading(false);
    this.refresh();
  };

  function init(context) {
    var scope = context || document;
    var roots = scope.matches && scope.matches(rootSelector)
      ? [scope]
      : Array.prototype.slice.call(scope.querySelectorAll(rootSelector));

    roots.forEach(function (root) {
      if (instances.has(root)) return;
      instances.set(root, new TalliCollectionFilters(root));
    });

    syncNativeSortVisibility();
  }

  function destroy(context) {
    var roots = Array.prototype.slice.call(context.querySelectorAll(rootSelector));
    roots.forEach(function (root) {
      var instance = instances.get(root);
      if (!instance) return;
      instance.destroy();
      instances.delete(root);
    });

    syncNativeSortVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });
})();
